export default __webpack_public_path__ + "static/media/Pop.0fab3bd9.mp3";